import React, { useEffect } from 'react';
export var useIsElementOverflowing = function () {
    var overflowingElement = React.useRef(null);
    var _a = React.useState(false), isOverflowing = _a[0], setIsOverflowing = _a[1];
    useEffect(function () {
        if (overflowingElement) {
            var _a = overflowingElement.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            setIsOverflowing(scrollHeight > clientHeight);
        }
    }, [overflowingElement]);
    return [overflowingElement, isOverflowing];
};
//# sourceMappingURL=isElementOverflowingHook.js.map